webpackJsonp([1],{

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(318)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(346),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cd8c8e4e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(22);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(31);

var _axios2 = _interopRequireDefault(_axios);

var _qs = __webpack_require__(211);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var http = _axios2.default.create({
  withCredentials: true
});

exports.default = {
  install: function install(Vue, options) {
    var api = options.api;

    Vue.prototype.$task = function () {
      var task = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var editable = ['status'];

      var defaultSave = false;
      var saveQueue = [];

      var all = function all() {
        var params = {
          function: 'tasks',
          method: 'getlist'
        };

        return new _promise2.default(function (resolve, reject) {
          http.post(api, _qs2.default.stringify(params)).then(function (response) {
            resolve(response.data.Data.rows);
          });
        });
      };

      var set = function set(key, value) {
        if (editable.indexOf(key) === -1) {
          return false;
        }

        if (typeof saveExceptions[key] !== 'undefined') {
          saveQueue.push(key);
        } else {
          defaultSave = true;
        }

        task[key] = value;
        return this;
      };

      var saveStatus = function saveStatus() {
        var params = {
          function: 'tasks',
          method: 'onoff',
          taskpk: task.pk,
          newstatus: task.status
        };

        http.post(api, _qs2.default.stringify(params)).then(function (response) {
          return response.data.Data.rows;
        });
      };

      var save = function save() {
        return new _promise2.default(function (resolve, reject) {
          for (var i = 0; saveQueue.length > i; i++) {
            saveExceptions[saveQueue[i]]();
          }
          if (defaultSave) {}
          resolve();
        });
      };

      var run = function run() {
        var params = {
          function: 'tasks',
          method: 'runnow',
          taskpk: task.pk
        };

        return new _promise2.default(function (resolve, reject) {
          http.post(api, _qs2.default.stringify(params)).then(function (response) {
            var status = response.statusText;
            if (status !== 'OK') {
              reject();
              return false;
            }
            resolve(response);
          });
        });
      };

      var saveExceptions = {
        'status': saveStatus
      };

      var log = function log() {
        return new _promise2.default(function (resolve, reject) {
          var params = {
            function: 'tasks',
            method: 'gettasklog',
            taskpk: task.pk
          };

          http.post(api, _qs2.default.stringify(params)).then(function (response) {
            resolve(response.data.Data.rows);
          });
        });
      };

      return {
        all: all,
        run: run,
        set: set,
        save: save,
        log: log
      };
    };

    Vue.prototype.$log = function () {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var item = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var editable = ['status'];

      var defaultSave = false;
      var saveQueue = [];

      var types = {
        error: {
          function: 'errorlog',
          all: {
            method: 'getlist'
          },
          count: {
            method: 'geterrorcount'
          }
        },
        task: {
          function: 'tasks',
          all: {
            method: 'gethistory'
          },
          find: {
            method: 'gettasklog'
          }
        }
      };

      var all = function all() {
        var params = types[type].all;
        params.function = types[type].function;

        return new _promise2.default(function (resolve, reject) {
          http.post(api, _qs2.default.stringify(params)).then(function (response) {
            resolve(response.data.Data.rows);
          });
        });
      };

      var detail = function detail() {
        return new _promise2.default(function (resolve, reject) {
          var params = {
            function: 'errorlog',
            method: 'geterrorlist',
            errortitle: item.title
          };

          http.post(api, _qs2.default.stringify(params)).then(function (response) {
            resolve(response.data.Data.rows);
          });
        });
      };
      var find = function find() {
        var pk = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        return new _promise2.default(function (resolve, reject) {
          if (typeof types[type].find === 'undefined') {
            reject('Unable to perform a lookup by PK on this log type');
          }
          if (pk === null) {
            reject('Find: must provide PK');
          }
          var params = {
            function: types[type].function,
            method: types[type].find.method,
            taskpk: pk
          };

          http.post(api, _qs2.default.stringify(params)).then(function (response) {
            resolve(response.data.Data.rows);
          });
        });
      };

      var set = function set(key, value) {
        if (editable.indexOf(key) === -1) {
          return false;
        }

        if (typeof saveExceptions[key] !== 'undefined') {
          saveQueue.push(key);
        } else {
          defaultSave = true;
        }

        item[key] = value;
        return this;
      };

      var save = function save() {
        return new _promise2.default(function (resolve, reject) {
          for (var i = 0; saveQueue.length > i; i++) {
            saveExceptions[saveQueue[i]]();
          }
          if (defaultSave) {}
          resolve();
        });
      };

      var saveStatus = function saveStatus() {
        var params = {
          function: 'errorlog',
          method: 'updatestatus',
          pk: item.pk,
          newstatus: item.status
        };
        http.post(api, _qs2.default.stringify(params)).then(function (response) {
          return response.data.Data.rows;
        });
      };

      var count = function count() {
        return new _promise2.default(function (resolve, reject) {
          if (typeof types[type].count === 'undefined') {
            reject('Unable to perform a lookup by PK on this log type');
          }

          var params = types[type].count;
          params.function = types[type].function;

          http.post(api, _qs2.default.stringify(params)).then(function (response) {
            if (typeof response.data.Data.rows[0] === 'undefined') {
              resolve(0);
              return;
            }
            resolve(response.data.Data.rows[0].count);
          });
        });
      };

      var saveExceptions = {
        'status': saveStatus
      };

      return {
        all: all,
        find: find,
        detail: detail,
        set: set,
        save: save,
        count: count
      };
    };
  }
};

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(22);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(31);

var _axios2 = _interopRequireDefault(_axios);

var _qs = __webpack_require__(211);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var http = _axios2.default.create({
  withCredentials: true
});

exports.default = {
  install: function install(Vue, options) {
    var api = options.api;
    var level = options.level;

    Vue.prototype.$user = function () {
      var step1 = function step1(value) {
        var params = {
          function: 'autho',
          method: 'pstep1',
          pid: value
        };

        return new _promise2.default(function (resolve, reject) {
          http.post(api, _qs2.default.stringify(params)).then(function (response) {
            var status = response.data.Function.success;
            if (!status) {
              reject();
              return false;
            }
            resolve();
          });
        });
      };

      var step2 = function step2(value) {
        var params = {
          function: 'autho',
          method: 'pstep2',
          code: value
        };

        return new _promise2.default(function (resolve, reject) {
          http.post(api, _qs2.default.stringify(params)).then(function (response) {
            var status = response.data.Function.success;
            if (!status) {
              reject();
              return false;
            }
            resolve();
          });
        });
      };

      var login = function login(user) {
        var params = {
          function: 'autho',
          method: 'login',
          site: level,
          username: user.username,
          password: user.password
        };

        return new _promise2.default(function (resolve, reject) {
          http.post(api, _qs2.default.stringify(params)).then(function (response) {
            var status = response.data.Function.success;
            if (!status) {
              reject(false);
              return false;
            }
            resolve(response.data.Data);
          });
        });
      };

      var logout = function logout() {
        var params = {
          function: 'autho',
          method: 'logout'
        };

        return new _promise2.default(function (resolve, reject) {
          http.post(api, _qs2.default.stringify(params)).then(function (response) {
            var status = response.data.Function.success;
            if (status !== true) {
              reject();
              return false;
            }
            resolve();
          });
        });
      };

      var isAuthenticated = function isAuthenticated() {
        var params = {
          function: 'autho',
          method: 'autho'
        };

        return new _promise2.default(function (resolve, reject) {
          http.post(api, _qs2.default.stringify(params)).then(function (response) {
            var status = response.data.Function.success;
            if (!status) {
              reject(status);
              return false;
            }
            resolve(true);
          });
        });
      };
      return {
        login: login,
        logout: logout,
        isAuthenticated: isAuthenticated,
        step1: step1,
        step2: step2
      };
    };
  }
};

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(33);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(347);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _Tasklog = __webpack_require__(336);

var _Tasklog2 = _interopRequireDefault(_Tasklog);

var _Logs = __webpack_require__(335);

var _Logs2 = _interopRequireDefault(_Logs);

var _Phone = __webpack_require__(331);

var _Phone2 = _interopRequireDefault(_Phone);

var _Console = __webpack_require__(332);

var _Console2 = _interopRequireDefault(_Console);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

exports.default = new _vueRouter2.default({
  routes: [{
    path: '',
    component: _Console2.default,
    children: [{
      name: 'logs',
      path: '/logs',
      component: _Logs2.default
    }, {
      name: 'tasks',
      path: '/',
      component: _Tasklog2.default
    }]
  }, {
    name: 'login',
    path: '/login',
    component: _Phone2.default
  }]
});

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(309);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(21)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../extract-text-webpack-plugin/loader.js??ref--5-0!../../../vue-style-loader/index.js!../../../css-loader/index.js??ref--5-2!./bootstrap.min.css", function() {
			var newContent = require("!!../../../extract-text-webpack-plugin/loader.js??ref--5-0!../../../vue-style-loader/index.js!../../../css-loader/index.js??ref--5-2!./bootstrap.min.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(319);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(21)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/extract-text-webpack-plugin/loader.js??ref--5-0!../../../../node_modules/vue-style-loader/index.js!../../../../node_modules/css-loader/index.js??ref--5-2!./bootstrap-progressbar-3.3.4.min.css", function() {
			var newContent = require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js??ref--5-0!../../../../node_modules/vue-style-loader/index.js!../../../../node_modules/css-loader/index.js??ref--5-2!./bootstrap-progressbar-3.3.4.min.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(320);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(21)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/extract-text-webpack-plugin/loader.js??ref--5-0!../../../../node_modules/vue-style-loader/index.js!../../../../node_modules/css-loader/index.js??ref--5-2!./custom.min.css", function() {
			var newContent = require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js??ref--5-0!../../../../node_modules/vue-style-loader/index.js!../../../../node_modules/css-loader/index.js??ref--5-2!./custom.min.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(321);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(21)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/extract-text-webpack-plugin/loader.js??ref--5-0!../../../../node_modules/vue-style-loader/index.js!../../../../node_modules/css-loader/index.js??ref--5-2!./font-awesome.min.css", function() {
			var newContent = require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js??ref--5-0!../../../../node_modules/vue-style-loader/index.js!../../../../node_modules/css-loader/index.js??ref--5-2!./font-awesome.min.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(322);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(21)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/extract-text-webpack-plugin/loader.js??ref--5-0!../../../../node_modules/vue-style-loader/index.js!../../../../node_modules/css-loader/index.js??ref--5-2!./jquery-jvectormap-2.0.3.css", function() {
			var newContent = require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js??ref--5-0!../../../../node_modules/vue-style-loader/index.js!../../../../node_modules/css-loader/index.js??ref--5-2!./jquery-jvectormap-2.0.3.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(316)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(344),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(33);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(223);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(217);

var _router2 = _interopRequireDefault(_router);

var _vueResource = __webpack_require__(225);

var _vueResource2 = _interopRequireDefault(_vueResource);

var _vueMoment = __webpack_require__(224);

var _vueMoment2 = _interopRequireDefault(_vueMoment);

var _vuex = __webpack_require__(14);

var _vuex2 = _interopRequireDefault(_vuex);

var _adminconsoleSdk = __webpack_require__(215);

var _adminconsoleSdk2 = _interopRequireDefault(_adminconsoleSdk);

var _authSdk = __webpack_require__(216);

var _authSdk2 = _interopRequireDefault(_authSdk);

var _axios = __webpack_require__(31);

var _axios2 = _interopRequireDefault(_axios);

var _store = __webpack_require__(32);

var _store2 = _interopRequireDefault(_store);

__webpack_require__(218);

__webpack_require__(221);

__webpack_require__(219);

__webpack_require__(222);

__webpack_require__(220);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.config.productionTip = false;

_vue2.default.use(_authSdk2.default, {
  api: 'https://api.edexis.com/wapi/',
  level: 1
});

_vue2.default.use(_adminconsoleSdk2.default, {
  api: 'https://api.edexis.com/wapi/',
  loginRouteName: 'login',
  ignoreRoutes: ['login', 'register', 'authreset']
});

_vue2.default.use(_vueResource2.default);
_vue2.default.use(_vueMoment2.default);

_vue2.default.use(_vuex2.default);

_axios2.default.interceptors.response.use(function (res) {
  if (res.data.Function.success === false) {
    undefined.$router.push({ name: 'login' });
    return;
  }

  return res;
});

new _vue2.default({
  el: '#app',
  router: _router2.default,
  store: _store2.default,
  template: '<App/>',
  components: { App: _App2.default }
});

_vue2.default.http.options.credentials = true;
_vue2.default.http.options.xhr = { withCredentials: true };
_vue2.default.http.options.emulateJSON = true;

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _store = __webpack_require__(32);

var _store2 = _interopRequireDefault(_store);

var _vuex = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'app',
  components: {
    store: _store2.default
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    this.$user().isAuthenticated().catch(function (e) {
      _this.$router.push('/login');
    });
  },

  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['updateUser']), {
    logout: function logout() {
      var _this2 = this;

      this.$user().logout().then(function () {
        _this2.$router.push('/login');
      });
    },
    toggleSidebar: function toggleSidebar() {
      if (this.size === 'large') {
        this.$set(this, 'size', 'small');
        return false;
      }
      this.$set(this, 'size', 'large');
    },
    getWidth: function getWidth() {
      console.log(document.body.scrollWidth);
      return document.body.scrollWidth;
    },
    checkWidth: function checkWidth() {
      if (this.getWidth() > this.hiddenWidth) {
        return false;
      }
      this.$set(this, 'size', 'large');
    }
  }),
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['user']))
};

/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(22);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'TwoPageAuth',
  data: function data() {
    return {
      user: '',
      password: '',
      message: '',
      currentStep: 1,
      totalSteps: 2,
      appLandingPage: 'tasks'
    };
  },
  mounted: function mounted() {
    this.$user().isAuthenticated().then(function () {
      console.log('always returns true');
    }).catch(function (e) {
      console.log(e);
    });
  },

  methods: {
    processCurrentStep: function processCurrentStep() {
      var _this = this;

      var method = 'processStep' + this.currentStep;

      this[method]().then(function (response) {
        if (_this.currentStep++ === _this.totalSteps) {
          _this.$router.push({ name: _this.appLandingPage });
          return false;
        }
        _this.$set(_this, 'currentStep', _this.currentStep++);
      }).catch(function (e) {
        _this.$set(_this, 'message', 'Login Attempt Failed');
      });
    },
    processStep1: function processStep1() {
      var _this2 = this;

      return new _promise2.default(function (resolve, reject) {
        _this2.$user().step1(_this2.user).then(function (response) {
          resolve();
        }).catch(function (e) {
          reject(e);
        });
      });
    },
    processStep2: function processStep2() {
      var _this3 = this;

      return new _promise2.default(function (resolve, reject) {
        _this3.$user().step2(_this3.password).then(function (response) {
          resolve();
        }).catch(function (e) {
          reject(e);
        });
      });
    }
  }
};

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _Sidebar = __webpack_require__(333);

var _Sidebar2 = _interopRequireDefault(_Sidebar);

var _Topmenu = __webpack_require__(334);

var _Topmenu2 = _interopRequireDefault(_Topmenu);

var _store = __webpack_require__(32);

var _store2 = _interopRequireDefault(_store);

var _vuex = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'app',
  components: {
    Sidebar: _Sidebar2.default,
    Topmenu: _Topmenu2.default,
    store: _store2.default
  },
  data: function data() {
    return {
      size: 'large',
      hiddenWidth: 900,
      menuItems: [{
        title: 'Tasks',
        name: 'tasks',
        icon: 'fa-tasks'
      }, {
        title: 'Error Logs',
        name: 'logs',
        icon: 'fa-print',
        pill: ''
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener('resize', this.checkWidth);

    this.$log('error').count().then(function (count) {
      _this.$set(_this.menuItems[1], 'pill', count);
    });
  },

  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['buildApiReqeust', 'updateUser']), {
    logout: function logout() {
      var _this2 = this;

      this.$user().logout().then(function () {
        _this2.$router.push('/login');
      });
    },
    toggleSidebar: function toggleSidebar() {
      if (this.size === 'large') {
        this.$set(this, 'size', 'small');
        return false;
      }
      this.$set(this, 'size', 'large');
    },
    getWidth: function getWidth() {
      return document.body.scrollWidth;
    },
    checkWidth: function checkWidth() {
      if (this.getWidth() > this.hiddenWidth) {
        return false;
      }
      this.$set(this, 'size', 'large');
    }
  }),
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['user'])),
  watch: {
    $route: function $route() {
      this.checkWidth();
    }
  }
};

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'Panel',
  props: {
    filter: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array
    },
    primaryKey: {
      type: String
    },
    searchFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      showPanel: true,
      filterText: ''
    };
  },

  methods: {
    clearSearch: function clearSearch() {
      this.$set(this, 'filterText', '');
    },
    togglePanelDisply: function togglePanelDisply() {
      this.showPanel = this.showPanel ? 0 : 1;
    },
    findKey: function findKey() {
      var matches = [];
      var regex = new RegExp('^.*' + this.filterText + '.*$', 'i');
      for (var i = 0; this.data.length > i; i++) {
        if (!regex.test(this.data[i].string)) {
          continue;
        }
        matches.push(this.data[i]);
      }
      this.$emit('matches', matches);
    },
    createSearchStrings: function createSearchStrings() {
      for (var i = 0; this.data.length > i; i++) {
        var searchString = '';
        for (var key in this.data[i]) {
          if (typeof this.data[i][key] !== 'string' && typeof this.data[i][key] !== 'number') {
            continue;
          }
          if (this.searchFields.length !== 0 && this.searchFields.indexOf(key) === -1) {
            continue;
          }
          searchString += this.data[i][key];
        }
        this.data[i].string = searchString;
      }
    }
  },
  watch: {
    filterText: function filterText() {
      return this.findKey();
    },
    data: function data() {
      this.createSearchStrings();
      this.$emit('matches', this.data);
    }
  }
};

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'sidebar',
  props: {
    title: {
      String: String
    },
    menuItems: {
      type: Array
    },
    logout: {
      type: Function
    }
  },
  data: function data() {
    return {
      time: ''
    };
  },
  mounted: function mounted() {
    this.updateTime();
  },

  methods: {
    logoutPress: function logoutPress() {
      this.logout();
    },
    updateTime: function updateTime() {
      var _this = this;

      setInterval(function () {
        var d = new Date();
        var month = (d.getMonth() + 1 < '10' ? '0' : '') + (d.getMonth() + 1);
        var dates = (d.getDate() < 10 ? '0' : '') + d.getDate();
        var year = d.getFullYear();
        var hours = (d.getHours() < 10 ? '0' : '') + d.getHours();
        var minutes = (d.getMinutes() < 10 ? '0' : '') + d.getMinutes();
        var seconds = (d.getSeconds() < 10 ? '0' : '') + d.getSeconds();

        var formatedString = month + '/' + dates + '/' + year + ' ' + hours + ':' + minutes + ':' + seconds;
        _this.$set(_this, 'time', formatedString);
      }, 1000);
    }
  }
};

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _UserPanel = __webpack_require__(337);

var _UserPanel2 = _interopRequireDefault(_UserPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'topmenu',
  components: {
    UserPanel: _UserPanel2.default
  },
  methods: {
    toggleSidebar: function toggleSidebar() {
      this.$emit('toggleSidebar');
    }
  }
};

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _vueStrap = __webpack_require__(214);

var _vuex = __webpack_require__(14);

var _Panel = __webpack_require__(213);

var _Panel2 = _interopRequireDefault(_Panel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Logs',
  components: {
    dropdown: _vueStrap.dropdown,
    'panel-block': _Panel2.default
  },
  data: function data() {
    return {
      allResolved: true,
      detailItem: '',
      details: {},
      log: {},

      showResolved: false,
      statusList: [{ pk: 1, title: 'New', style: 'danger' }, { pk: 2, title: 'Acknowledged', style: 'warning' }, { pk: 3, title: 'Investigating', style: 'info' }, { pk: 4, title: 'Resolved', style: 'success' }]
    };
  },
  mounted: function mounted() {
    this.getErrorLogs();
  },

  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['buildApiReqeust', 'updateUser']), {
    openDetail: function openDetail(item) {
      this.$set(this, 'detailItem', item);
      this.getDetail(item);
    },
    getDetail: function getDetail(item) {
      var _this = this;

      this.$log('error', item).detail().then(function (response) {
        _this.$set(_this.details, item.pk, response);
      });
    },
    closeDetail: function closeDetail() {
      this.$set(this, 'detailItem', '');
    },
    toggleShowResolved: function toggleShowResolved() {
      if (this.showResolved === true) {
        this.$set(this, 'showResolved', false);
        return false;
      }
      this.$set(this, 'showResolved', true);
    },
    getErrorLogs: function getErrorLogs() {
      var _this2 = this;

      var pk = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.$set(this, 'log', '');
      this.$log('error').all().then(function (response) {
        _this2.parseLogs(response);
      });
    },
    callApi: function callApi(request) {
      var _this3 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.$http[request.type](request.url, request.params).then(function (response) {
        if (callback === null) {
          return 'success';
        }
        _this3[callback](response);
      });
    },
    parseLogs: function parseLogs(data) {
      data.reverse();
      for (var i = 0; data.length > i; i++) {
        if (data[i].status === 0) {
          data[i].status = 1;
        }
        if (data[i].status !== 4) {
          this.getDetail(data[i]);
        } else {
          this.$set(this, 'allResolved', true);
        }
      }
      this.$set(this, 'log', data);
    },
    changeStatus: function changeStatus(item, status) {
      this.$log('error', item).set('status', status.pk).save().then(function (response) {});
    }
  }),
  computed: {
    logFiltered: function logFiltered() {
      if (this.showResolved === true) {
        return this.log;
      }

      var list = [];
      for (var i = 0; this.log.length > i; i++) {
        if (this.log[i].status === 4) {
          continue;
        }
        list.push(this.log[i]);
      }
      return list;
    }
  }
};

/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(22);

var _promise2 = _interopRequireDefault(_promise);

var _typeof2 = __webpack_require__(57);

var _typeof3 = _interopRequireDefault(_typeof2);

var _stringify = __webpack_require__(254);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _vueStrap = __webpack_require__(214);

var _vuex = __webpack_require__(14);

var _Panel = __webpack_require__(213);

var _Panel2 = _interopRequireDefault(_Panel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'tasklog',
  components: {
    dropdown: _vueStrap.dropdown,
    'panel-block': _Panel2.default
  },
  data: function data() {
    return {
      tasks: [],
      runningTask: '',
      sort: {
        column: 'id',
        direction: 'desc'
      },
      log: [],
      displayModal: false,
      pageTitle: 'test',
      currentLogTask: '',
      currentTask: '',
      statusList: [{ pk: 0, title: 'Inactive', style: 'default' }, { pk: 1, title: 'Active', style: 'success' }, { pk: 2, title: 'Off', style: 'danger' }, { pk: 3, title: 'On Demand', style: 'info' }, { pk: 4, title: 'Linked', style: 'warning' }, { pk: 5, title: 'Linked', style: 'warning' }],
      filteredTasks: [],
      filteredLogs: []
    };
  },
  mounted: function mounted() {
    this.getTasks();
    this.getLogs();
  },

  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['buildApiReqeust', 'updateUser']), {
    setSortColumn: function setSortColumn(id) {
      var sortDirection = 'desc';
      if (id === this.sort.column && this.sort.direction === 'desc') {
        sortDirection = 'asc';
      }

      this.$set(this.sort, 'column', id);
      this.$set(this.sort, 'direction', sortDirection);
      var items = this.sortTaskList(this.filteredTasks);
      this.$set(this, 'filteredTasks', items);
    },
    filterMatches: function filterMatches(type, items) {
      if (type === 'Tasks') {
        items = this.sortTaskList(items);
      }
      this.$set(this, 'filtered' + type, items);
    },
    sortTaskList: function sortTaskList(items) {
      var _this = this;

      var list = JSON.parse((0, _stringify2.default)(items));
      var key = this.sort.column;
      return list.sort(function (a, b) {
        if (_this.sort.direction === 'desc') {
          return (a[key] > b[key]) - (a[key] < b[key]);
        }
        return (a[key] < b[key]) - (a[key] > b[key]);
      });
    },
    changeTaskStatus: function changeTaskStatus(task, newStatus) {
      this.$task(task).set('status', newStatus.pk).save().then(function (response) {});
    },
    clearCurrentRunningTask: function clearCurrentRunningTask() {
      this.$set(this, 'runningTask', '');
      this.$set(this, 'displayModal', false);
    },
    taskRunConfirmation: function taskRunConfirmation() {
      var task = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.$set(this, 'runningTask', task);
      this.$set(this, 'displayModal', true);
    },
    runTaskNow: function runTaskNow(task) {
      var _this2 = this;

      this.$set(this, 'displayModal', false);
      this.$task(task).run().then(function (response) {
        if (response.data.Function.success === false) {
          _this2.$set(_this2, 'displayModal', false);
          _this2.$set(_this2, 'runningTask', task);
          return false;
        }
        _this2.$set(_this2, 'runningTask', '');
        _this2.$set(_this2, 'displayModal', false);
        _this2.getLogs();
      });
    },
    toggleLogsListDisply: function toggleLogsListDisply() {
      this.showLogs = this.showLogs ? 0 : 1;
    },
    getLogs: function getLogs() {
      var _this3 = this;

      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.$set(this, 'log', []);
      this.currentLogTask = '';
      if (item !== null) {
        this.$set(this, 'currentLogTask', item);
        this.$task(item).log().then(function (response) {
          var logs = _this3.parseLogs(response);
          _this3.$set(_this3, 'log', logs);
        }).catch(function (e) {
          console.log(e);
        });
        return false;
      }

      this.$log('task').all().then(function (response) {
        var logs = _this3.parseLogs(response);
        _this3.$set(_this3, 'log', logs);
      });
    },
    parseLogs: function parseLogs(response) {
      var pk = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      return this.attachLogItem(response);
    },
    attachLogItem: function attachLogItem(item, pk) {
      if ((typeof item === 'undefined' ? 'undefined' : (0, _typeof3.default)(item)) === 'object' && (0, _typeof3.default)(item[0]) === 'object') {
        for (var i = 0; item.length > i; i++) {
          item[i] = this.attachLogItem(item[i], pk);
        }
        return item;
      }

      item.pk = pk;
      if (pk === null) {
        var regex = /\(([A-Z0-9]{2,3})\)\s?(.*)/;
        var matches = regex.exec(item.title);
        if (matches === null) {
          return item;
        }
        try {
          item.pk = this.getTaskByTitle(item.title).pk;
          item.id = matches[1];
          item.title = matches[2];
        } catch (e) {
          console.log(e);
        }
      }
      return item;
    },
    getTasks: function getTasks() {
      var _this4 = this;

      var task = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return new _promise2.default(function (resolve, reject) {
        if (task !== null) {
          var pk = task.pk !== null ? task.pk : task.task_pk;
          _this4.$set(_this4, 'currentTask', _this4.getTaskByPk(pk));
          return false;
        }
        _this4.$set(_this4, 'currentTask', '');
        _this4.$task().all().then(function (response) {
          _this4.parseTasks(response);
          resolve();
        });
      });
    },
    parseTasks: function parseTasks() {
      var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var tasks = response;
      var newList = response;

      for (var i = 0; tasks.length > i; i++) {
        var regex = /\(([A-Z0-9]{2,3})\)\s?(.*)/;
        var matches = regex.exec(tasks[i].title);
        if (matches === null) {
          continue;
        }
        try {
          newList[i].origTitle = tasks[i].title;
          newList[i].id = matches[1] ? matches[1] : '';
          newList[i].title = matches[2] ? matches[2] : '';
          newList[i].runtime = matches[3] ? matches[3] : '';
        } catch (e) {
          console.log(e);
          continue;
        }
      }
      this.$set(this, 'tasks', newList);
    },
    getTaskByTitle: function getTaskByTitle(title) {
      for (var i = 0; this.tasks.length > i; i++) {
        if (this.tasks[i].origTitle === title) {
          return this.tasks[i];
        }
      }
    },
    getTaskByPk: function getTaskByPk(pk) {
      for (var i = 0; i < this.tasks.length; i++) {
        if (this.tasks[i].pk === pk) {
          return this.tasks[i];
        }
      }
    },
    hhmmss: function hhmmss(seconds) {
      var minutes = Math.floor(seconds / 60);
      var hours = Math.floor(minutes / 60);

      minutes = minutes % 60;
      seconds = seconds % 60;
      var time = '';
      if (hours !== 0) {
        time += hours + ':';
      }
      if (minutes < 10 && minutes !== 0) {
        time += '0' + minutes + ':';
      }
      if (seconds < 10 && seconds !== 0) {
        time += '0' + seconds;
      }

      return time;
    }
  }),
  watch: {
    log: function log() {
      if (this.tasks.length === 0) {
        return false;
      }
      this.attachLogItem(this.log, null);
    },
    tasks: function tasks() {
      if (this.log.length === 0) {
        return false;
      }
      this.attachLogItem(this.log, null);
    }
  }
};

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(57);

var _typeof3 = _interopRequireDefault(_typeof2);

var _md = __webpack_require__(324);

var _md2 = _interopRequireDefault(_md);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'UserPanel',
  data: function data() {
    return {
      user: {
        email: '',
        photoUrl: ''
      }
    };
  },
  mounted: function mounted() {
    this.setUserPhoto();
  },

  methods: {
    setUserPhoto: function setUserPhoto() {
      var hash = '';
      if ((0, _typeof3.default)(this.user.email) !== undefined && this.user.email !== '') {
        hash = (0, _md2.default)(this.user.email);
      }
      console.log(hash);
      var url = 'https://www.gravatar.com/avatar/' + hash + '?d=mm';
      this.$set(this.user, 'photoUrl', url);
    },
    logout: function logout() {
      var _this = this;

      this.$user().logout().then(function (response) {
        _this.$router.push('/login');
      });
    }
  }
};

/***/ }),

/***/ 309:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 310:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 311:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 312:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 313:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 314:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 315:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 316:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 317:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 318:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 319:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(260);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _slicedToArray2 = __webpack_require__(261);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = __webpack_require__(257);

var _entries2 = _interopRequireDefault(_entries);

var _getIterator2 = __webpack_require__(56);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _vue = __webpack_require__(33);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(14);

var _vuex2 = _interopRequireDefault(_vuex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
  state: {
    user: {
      loginTime: '',
      dispalyOptions: ''
    },
    app: {
      api: {
        protocol: 'https',
        path: '/webengine/webapi20.avfp',
        entry: 'func',
        type: 'get',
        domain: {
          'default': 'api.edexis.com'
        },
        request: {
          login: {
            type: 'post',
            task: 'log_login',
            option: {
              user: true,
              password: true
            }
          },
          logout: {
            task: 'log_logout'
          }
        }
      }
    }
  },

  mutations: {
    setRouteOptions: function setRouteOptions(state, request) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)((0, _entries2.default)(request)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
              name = _step$value[0],
              options = _step$value[1];

          state.app.api.request[name].request = {};
          state.app.api.request[name].request.params = {};
          for (var key in state.app.api.request[name].option) {
            state.app.api.request[name].request.params[key] = options[key];
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    buildRequest: function buildRequest(state, name) {
      console.log(name);
      var route = state.app.api.request[name];
      route.request.type = route.type ? route.type : state.app.api.type;

      route.request.url = state.app.api.protocol + '://';
      route.request.url += state.app.api.domain.default;
      route.request.url += state.app.api.path;

      if (route.request.type === 'get') {
        route.request.queryString = '';
        route.request.url += '?' + state.app.api.entry + '=' + route.task;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = (0, _getIterator3.default)((0, _entries2.default)(route.request.params)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _step2$value = (0, _slicedToArray3.default)(_step2.value, 2),
                key = _step2$value[0],
                value = _step2$value[1];

            route.request.queryString += '&' + key + '=' + value;
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        route.request.url += route.request.queryString;
      } else {
        route.request.params[state.app.api.entry] = route.task;
      }
    },
    updateUser: function updateUser(state, user) {
      window.localStorage.setItem('user', user);
    }
  },

  actions: {
    buildApiReqeust: function buildApiReqeust(_ref, request) {
      var commit = _ref.commit,
          state = _ref.state,
          getters = _ref.getters;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = (0, _getIterator3.default)((0, _entries2.default)(request)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _step3$value = (0, _slicedToArray3.default)(_step3.value, 2),
              name = _step3$value[0],
              options = _step3$value[1];

          commit('setRouteOptions', (0, _defineProperty3.default)({}, name, options));
          commit('buildRequest', name);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return state.app.api.request[name].request;
    },
    updateUser: function updateUser(_ref2, user) {
      var commit = _ref2.commit,
          state = _ref2.state,
          getters = _ref2.getters;

      commit('updateUser', user);
    }
  },

  getters: {
    user: function user(state) {
      return window.localStorage.getItem('user');
    }
  }
});

/***/ }),

/***/ 320:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 321:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 322:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 74,
	"./af.js": 74,
	"./ar": 81,
	"./ar-dz": 75,
	"./ar-dz.js": 75,
	"./ar-kw": 76,
	"./ar-kw.js": 76,
	"./ar-ly": 77,
	"./ar-ly.js": 77,
	"./ar-ma": 78,
	"./ar-ma.js": 78,
	"./ar-sa": 79,
	"./ar-sa.js": 79,
	"./ar-tn": 80,
	"./ar-tn.js": 80,
	"./ar.js": 81,
	"./az": 82,
	"./az.js": 82,
	"./be": 83,
	"./be.js": 83,
	"./bg": 84,
	"./bg.js": 84,
	"./bm": 85,
	"./bm.js": 85,
	"./bn": 87,
	"./bn-bd": 86,
	"./bn-bd.js": 86,
	"./bn.js": 87,
	"./bo": 88,
	"./bo.js": 88,
	"./br": 89,
	"./br.js": 89,
	"./bs": 90,
	"./bs.js": 90,
	"./ca": 91,
	"./ca.js": 91,
	"./cs": 92,
	"./cs.js": 92,
	"./cv": 93,
	"./cv.js": 93,
	"./cy": 94,
	"./cy.js": 94,
	"./da": 95,
	"./da.js": 95,
	"./de": 98,
	"./de-at": 96,
	"./de-at.js": 96,
	"./de-ch": 97,
	"./de-ch.js": 97,
	"./de.js": 98,
	"./dv": 99,
	"./dv.js": 99,
	"./el": 100,
	"./el.js": 100,
	"./en-au": 101,
	"./en-au.js": 101,
	"./en-ca": 102,
	"./en-ca.js": 102,
	"./en-gb": 103,
	"./en-gb.js": 103,
	"./en-ie": 104,
	"./en-ie.js": 104,
	"./en-il": 105,
	"./en-il.js": 105,
	"./en-in": 106,
	"./en-in.js": 106,
	"./en-nz": 107,
	"./en-nz.js": 107,
	"./en-sg": 108,
	"./en-sg.js": 108,
	"./eo": 109,
	"./eo.js": 109,
	"./es": 113,
	"./es-do": 110,
	"./es-do.js": 110,
	"./es-mx": 111,
	"./es-mx.js": 111,
	"./es-us": 112,
	"./es-us.js": 112,
	"./es.js": 113,
	"./et": 114,
	"./et.js": 114,
	"./eu": 115,
	"./eu.js": 115,
	"./fa": 116,
	"./fa.js": 116,
	"./fi": 117,
	"./fi.js": 117,
	"./fil": 118,
	"./fil.js": 118,
	"./fo": 119,
	"./fo.js": 119,
	"./fr": 122,
	"./fr-ca": 120,
	"./fr-ca.js": 120,
	"./fr-ch": 121,
	"./fr-ch.js": 121,
	"./fr.js": 122,
	"./fy": 123,
	"./fy.js": 123,
	"./ga": 124,
	"./ga.js": 124,
	"./gd": 125,
	"./gd.js": 125,
	"./gl": 126,
	"./gl.js": 126,
	"./gom-deva": 127,
	"./gom-deva.js": 127,
	"./gom-latn": 128,
	"./gom-latn.js": 128,
	"./gu": 129,
	"./gu.js": 129,
	"./he": 130,
	"./he.js": 130,
	"./hi": 131,
	"./hi.js": 131,
	"./hr": 132,
	"./hr.js": 132,
	"./hu": 133,
	"./hu.js": 133,
	"./hy-am": 134,
	"./hy-am.js": 134,
	"./id": 135,
	"./id.js": 135,
	"./is": 136,
	"./is.js": 136,
	"./it": 138,
	"./it-ch": 137,
	"./it-ch.js": 137,
	"./it.js": 138,
	"./ja": 139,
	"./ja.js": 139,
	"./jv": 140,
	"./jv.js": 140,
	"./ka": 141,
	"./ka.js": 141,
	"./kk": 142,
	"./kk.js": 142,
	"./km": 143,
	"./km.js": 143,
	"./kn": 144,
	"./kn.js": 144,
	"./ko": 145,
	"./ko.js": 145,
	"./ku": 146,
	"./ku.js": 146,
	"./ky": 147,
	"./ky.js": 147,
	"./lb": 148,
	"./lb.js": 148,
	"./lo": 149,
	"./lo.js": 149,
	"./lt": 150,
	"./lt.js": 150,
	"./lv": 151,
	"./lv.js": 151,
	"./me": 152,
	"./me.js": 152,
	"./mi": 153,
	"./mi.js": 153,
	"./mk": 154,
	"./mk.js": 154,
	"./ml": 155,
	"./ml.js": 155,
	"./mn": 156,
	"./mn.js": 156,
	"./mr": 157,
	"./mr.js": 157,
	"./ms": 159,
	"./ms-my": 158,
	"./ms-my.js": 158,
	"./ms.js": 159,
	"./mt": 160,
	"./mt.js": 160,
	"./my": 161,
	"./my.js": 161,
	"./nb": 162,
	"./nb.js": 162,
	"./ne": 163,
	"./ne.js": 163,
	"./nl": 165,
	"./nl-be": 164,
	"./nl-be.js": 164,
	"./nl.js": 165,
	"./nn": 166,
	"./nn.js": 166,
	"./oc-lnc": 167,
	"./oc-lnc.js": 167,
	"./pa-in": 168,
	"./pa-in.js": 168,
	"./pl": 169,
	"./pl.js": 169,
	"./pt": 171,
	"./pt-br": 170,
	"./pt-br.js": 170,
	"./pt.js": 171,
	"./ro": 172,
	"./ro.js": 172,
	"./ru": 173,
	"./ru.js": 173,
	"./sd": 174,
	"./sd.js": 174,
	"./se": 175,
	"./se.js": 175,
	"./si": 176,
	"./si.js": 176,
	"./sk": 177,
	"./sk.js": 177,
	"./sl": 178,
	"./sl.js": 178,
	"./sq": 179,
	"./sq.js": 179,
	"./sr": 181,
	"./sr-cyrl": 180,
	"./sr-cyrl.js": 180,
	"./sr.js": 181,
	"./ss": 182,
	"./ss.js": 182,
	"./sv": 183,
	"./sv.js": 183,
	"./sw": 184,
	"./sw.js": 184,
	"./ta": 185,
	"./ta.js": 185,
	"./te": 186,
	"./te.js": 186,
	"./tet": 187,
	"./tet.js": 187,
	"./tg": 188,
	"./tg.js": 188,
	"./th": 189,
	"./th.js": 189,
	"./tk": 190,
	"./tk.js": 190,
	"./tl-ph": 191,
	"./tl-ph.js": 191,
	"./tlh": 192,
	"./tlh.js": 192,
	"./tr": 193,
	"./tr.js": 193,
	"./tzl": 194,
	"./tzl.js": 194,
	"./tzm": 196,
	"./tzm-latn": 195,
	"./tzm-latn.js": 195,
	"./tzm.js": 196,
	"./ug-cn": 197,
	"./ug-cn.js": 197,
	"./uk": 198,
	"./uk.js": 198,
	"./ur": 199,
	"./ur.js": 199,
	"./uz": 201,
	"./uz-latn": 200,
	"./uz-latn.js": 200,
	"./uz.js": 201,
	"./vi": 202,
	"./vi.js": 202,
	"./x-pseudo": 203,
	"./x-pseudo.js": 203,
	"./yo": 204,
	"./yo.js": 204,
	"./zh-cn": 205,
	"./zh-cn.js": 205,
	"./zh-hk": 206,
	"./zh-hk.js": 206,
	"./zh-mo": 207,
	"./zh-mo.js": 207,
	"./zh-tw": 208,
	"./zh-tw.js": 208
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 325;

/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(310)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(338),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(317)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(345),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(311)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(339),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0dacb2f1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 334:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(314)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(342),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(315)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(343),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4ea7546e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(313)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(341),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(312)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(340),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 338:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login_wrapper"
  }, [_c('div', {
    staticClass: "animate form login_form"
  }, [_c('section', {
    staticClass: "login_content"
  }, [_c('h1', [_vm._v("Login")]), _vm._v(" "), (_vm.message) ? _c('div', {
    staticClass: "alert alert-warning alert-dismissible fade in"
  }, [_vm._v("\n          " + _vm._s(_vm.message) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.currentStep === 1) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user),
      expression: "user"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Username"
    },
    domProps: {
      "value": (_vm.user)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.processCurrentStep()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === 2) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.processCurrentStep()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.processCurrentStep()
      }
    }
  }, [_vm._v("Log in")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "separator"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', [_c('h1', [_vm._v("EDEXIS")]), _vm._v(" "), _c('p', [_vm._v("©2016 All Rights Reserved. EDEXIS")])])])
}]}

/***/ }),

/***/ 339:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 left_col menu_fixed"
  }, [_c('div', {
    staticClass: "left_col scroll-view"
  }, [_c('div', {
    staticClass: "navbar nav_title",
    staticStyle: {
      "border": "0"
    }
  }, [_c('router-link', {
    staticClass: "site_title",
    attrs: {
      "to": {
        name: 'tasks'
      }
    }
  }, [_c('span', [_vm._v("\n          " + _vm._s(_vm.title ? _vm.title : 'Edexis') + "\n        ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "main_menu_side hidden-print main_menu",
    attrs: {
      "id": "sidebar-menu"
    }
  }, [_c('div', {
    staticClass: "menu_section active"
  }, [_c('ul', {
    staticClass: "nav side-menu"
  }, _vm._l((_vm.menuItems), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "exact": "",
        "to": {
          name: item.name
        }
      }
    }, [_c('i', {
      staticClass: "fa",
      class: item.icon
    }), _vm._v("\n              " + _vm._s(item.title) + "\n              "), (typeof item.pill !== 'undefined') ? _c('span', {
      staticClass: "label label-success pull-right"
    }, [_vm._v("\n                " + _vm._s(item.pill) + "\n              ")]) : _vm._e()])], 1)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-footer"
  }, [_c('h5', {
    staticClass: "hidden-sm time"
  }, [_vm._v("\n        " + _vm._s(_vm.time) + "\n      ")]), _vm._v(" "), _c('a', {
    staticClass: "pointer pull-right",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logoutPress()
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-off",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])
},staticRenderFns: []}

/***/ }),

/***/ 340:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "user-profile dropdown-toggle"
  }, [_c('img', {
    attrs: {
      "src": _vm.user.photoUrl,
      "alt": ""
    }
  }), _vm._v("\n    " + _vm._s(_vm.user.first) + " " + _vm._s(_vm.user.last) + "\n    "), _c('span', {
    staticClass: " fa fa-angle-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-usermenu pull-right"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out pull-right"
  }), _vm._v(" Log Out")])])])])
},staticRenderFns: []}

/***/ }),

/***/ 341:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-7 col-sm-6 col-xs-12"
  }, [_c('panel-block', {
    attrs: {
      "filter": true && typeof _vm.currentTask !== 'object',
      "data": _vm.tasks,
      "primaryKey": "pk",
      "searchFields": [
        'ckay',
        'pk',
        'cycle',
        'timestamp',
        'last',
        'id',
        'origTitle',
        'title',
        'type'
      ]
    },
    on: {
      "matches": function($event) {
        return _vm.filterMatches('Tasks', $event)
      }
    }
  }, [_c('h2', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n        Tasks"), (_vm.currentTask) ? _c('span', [_vm._v(" - "), _c('a', {
    staticClass: "text-danger",
    on: {
      "click": function($event) {
        return _vm.getTasks()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" - " + _vm._s(_vm.currentTask.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "row table-row hidden-xs hidden-sm hidden-md"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.setSortColumn('id')
      }
    }
  }, [(_vm.sort.column === 'id') ? _c('i', {
    class: [
      'fa',
      'fa-sort-' + _vm.sort.direction
    ]
  }) : _c('i', {
    class: [
      'fa fa-sort' ]
  }), _vm._v(" "), _c('strong', [_vm._v("#")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.setSortColumn('title')
      }
    }
  }, [(_vm.sort.column === 'title') ? _c('i', {
    class: [
      'fa',
      'fa-sort-' + _vm.sort.direction
    ]
  }) : _c('i', {
    class: [
      'fa fa-sort' ]
  }), _vm._v(" "), _c('strong', [_vm._v("Name")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.setSortColumn('status')
      }
    }
  }, [(_vm.sort.column === 'status') ? _c('i', {
    class: [
      'fa',
      'fa-sort-' + _vm.sort.direction
    ]
  }) : _c('i', {
    class: [
      'fa fa-sort' ]
  }), _vm._v(" "), _c('strong', [_vm._v("Status")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.setSortColumn('next')
      }
    }
  }, [(_vm.sort.column === 'next') ? _c('i', {
    class: [
      'fa',
      'fa-sort-' + _vm.sort.direction
    ]
  }) : _c('i', {
    class: [
      'fa fa-sort' ]
  }), _vm._v(" "), _c('strong', [_vm._v("Next Run")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('strong', [_vm._v("Run")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.tasks) ? _c('div', {
    staticClass: "col-xs-12 table-striped"
  }, _vm._l((_vm.filteredTasks), function(task) {
    return ((!_vm.currentTask || task.pk == _vm.currentTask.pk)) ? _c('div', {
      staticClass: "row",
      class: [(_vm.currentLogTask && _vm.currentLogTask.pk !== task.pk) ? 'hidden-xs' : '']
    }, [_c('div', {
      staticClass: "col-lg-4 col-xs-8"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-2"
    }, [_c('strong', [_vm._v(_vm._s(task.id))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-10"
    }, [_vm._v("\n                    " + _vm._s(task.title) + "\n                    "), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm._f("moment")(task.last, "calendar")))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-10 col-xs-offset-2 hidden-lg"
    }, [_c('p', [_c('br'), _c('span', {
      staticClass: "hidden-lg"
    }, [_c('strong', [_vm._v("Next Run:")]), _c('br')]), _c('small', [_vm._v(_vm._s(_vm._f("moment")(task.next, "calendar")))])])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-8 col-xs-4"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-3 col-xs-12 hidden-xs",
      staticStyle: {
        "margin-bottom": "5px"
      }
    }, [_c('dropdown', {
      staticClass: "btn-block",
      attrs: {
        "text": _vm.statusList[task.status].title,
        "size": "sm",
        "type": _vm.statusList[task.status].style
      }
    }, _vm._l((_vm.statusList), function(status) {
      return _c('li', {
        staticClass: "btn-block"
      }, [_c('button', {
        staticClass: "btn-block btn-link",
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.changeTaskStatus(task, status)
          }
        }
      }, [_vm._v(_vm._s(status.title))])])
    }), 0)], 1), _vm._v(" "), _c('div', {
      staticClass: "col-lg-4 hidden-xs hidden-sm hidden-md"
    }, [(task.status == 1) ? _c('p', [_vm._v(_vm._s(_vm._f("moment")(task.next, "calendar")))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 hidden-sm hidden-md hidden-lg",
      staticStyle: {
        "margin-bottom": "5px"
      }
    }, [_c('dropdown', {
      staticClass: "btn-block",
      attrs: {
        "text": _vm.statusList[task.status].title,
        "size": "sm",
        "type": _vm.statusList[task.status].style
      }
    }, _vm._l((_vm.statusList), function(status) {
      return _c('li', {
        staticClass: "btn-block"
      }, [_c('button', {
        staticClass: "btn-block btn-link",
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.changeTaskStatus(task, status)
          }
        }
      }, [_vm._v(_vm._s(status.title))])])
    }), 0)], 1), _vm._v(" "), _c('div', {
      staticClass: "col-lg-3 col-xs-12"
    }, [(task.status !== '0') ? _c('button', {
      staticClass: "btn btn-default btn-sm btn-block",
      domProps: {
        "innerHTML": _vm._s(
          typeof _vm.runningTask === 'object' && _vm.runningTask.pk === task.pk ? 'Running' : 'Run Now'
        )
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.taskRunConfirmation(task)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-2 col-xs-12"
    }, [(_vm.currentLogTask.pk != task.pk) ? _c('button', {
      staticClass: "btn btn-block btn-warning btn-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.getLogs(task)
        }
      }
    }, [_vm._v("Log")]) : _vm._e(), _vm._v(" "), (_vm.currentLogTask.pk == task.pk) ? _c('button', {
      staticClass: "btn btn-block btn-danger btn-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.getLogs()
        }
      }
    }, [_vm._v("Clear")]) : _vm._e()])])])]) : _vm._e()
  }), 0) : _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-4x fa-spin fa-spinner loader"
  })])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 col-sm-6 col-xs-12"
  }, [_c('panel-block', {
    attrs: {
      "filter": true && typeof _vm.currentLogTask !== 'object',
      "data": _vm.log,
      "primaryKey": "pk"
    },
    on: {
      "matches": function($event) {
        return _vm.filterMatches('Logs', $event)
      }
    }
  }, [_c('h2', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n        Task Log"), (_vm.currentLogTask) ? _c('span', [_vm._v(" - "), _c('a', {
    staticClass: "text-danger",
    on: {
      "click": function($event) {
        return _vm.getLogs()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" - " + _vm._s(_vm.currentLogTask.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "row table-row hidden-xs hidden-sm hidden-md"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-10 col-xs-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-1"
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-xs-8"
  }, [_c('strong', [_vm._v("Name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('strong', [_vm._v("Run Times")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-xs-2"
  }, [_c('div', {
    staticClass: "col-md-2"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.log.length > 0 && _vm.tasks.length > 0) ? _c('div', {
    staticClass: "col-xs-12 table-striped"
  }, _vm._l((_vm.filteredLogs), function(item) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-10 col-xs-10"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-1 col-xs-1"
    }, [_c('strong', [_vm._v(_vm._s(!_vm.currentLogTask ? item.id : _vm.currentLogTask.id))])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-6 col-xs-8"
    }, [_vm._v("\n                    " + _vm._s(!_vm.currentLogTask ? item.title : _vm.currentLogTask.title) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-5 col-lg-offset-0 col-xs-8 col-xs-offset-1"
    }, [_c('br', {
      staticClass: "hidden-lg"
    }), _vm._v("\n                    " + _vm._s(_vm._f("moment")(item.start, "MMM DD")) + " — "), _c('strong', [_vm._v(_vm._s(item.dur) + " Second")]), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(_vm._f("moment")(item.start, "hh:mm:ss")) + " — " + _vm._s(_vm._f("moment")(item.end, "hh:mm:ss A")) + "\n                  ")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-2 col-xs-2"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-12"
    }, [(!_vm.currentLogTask) ? _c('button', {
      staticClass: "btn btn-default btn-sm",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.getLogs(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-filter"
    })]) : _vm._e(), _vm._v(" "), (_vm.currentTask.pk !== item.pk) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.getTasks(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-search"
    })]) : _vm._e(), _vm._v(" "), (_vm.currentTask.pk === item.pk) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.getTasks()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]) : _vm._e()])])])])
  }), 0) : _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-4x fa-spin fa-spinner loader"
  })])])])])], 1), _vm._v(" "), _c('div', {
    class: [
      'modal fade bs-example-modal-sm',
      _vm.displayModal ? 'in visible-lg-block visible-md-block visible-sm-block visible-xs-block' : 'hidden-xs'
    ],
    staticStyle: {
      "padding-right": "15px"
    },
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.clearCurrentRunningTask()
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.runningTask.id) + ": " + _vm._s(_vm.runningTask.title))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_c('strong', [_vm._v("Next:")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.runningTask.next, "calendar")))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Last:")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.runningTask.last, "calendar")))]), _vm._v(" "), _c('h4', [_vm._v("Are you Sure?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clearCurrentRunningTask()
      }
    }
  }, [_vm._v("\n            Cancel\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.runTaskNow(_vm.runningTask)
      }
    }
  }, [_vm._v("\n            Run Now\n            ")])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 342:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top_nav"
  }, [_c('div', {
    staticClass: "nav_menu"
  }, [_c('nav', {
    attrs: {
      "role": "navigation"
    }
  }, [_c('div', {
    staticClass: "nav toggle"
  }, [_c('a', {
    attrs: {
      "id": "menu_toggle"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleSidebar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('UserPanel')], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ 343:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('panel-block', [_c('h2', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n        Error Logs\n      ")]), _vm._v(" "), _c('li', {
    staticClass: "dropdown",
    attrs: {
      "slot": "toolbar-start"
    },
    slot: "toolbar-start"
  }, [(_vm.showResolved === false) ? _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "title": "Show Resolved Log Items"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleShowResolved()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  })]) : _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "title": "Hide Resolved Log Items"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleShowResolved()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye-slash"
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "row table-row hidden-xs hidden-sm hidden-md"
  }, [(!_vm.allResolved) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-1"
  }, [_c('strong')]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-8"
  }, [_c('strong', [_vm._v("Time")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7"
  }, [_c('strong', [_vm._v("Title/Message")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-1"
  }, [_c('strong', {
    staticClass: "pull-right"
  }, [_vm._v("Status")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-xs-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.log) ? _c('div', {
    staticClass: "col-xs-12 table table-hover"
  }, _vm._l((_vm.logFiltered), function(item) {
    return _c('div', {
      class: [
        'row',
        item.status === 4 ? 'success' : ''
      ]
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-2 col-xs-12 pull-right"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-8"
    }, [_c('dropdown', {
      staticClass: "btn-block",
      attrs: {
        "text": _vm.statusList[item.status - 1].title,
        "size": "sm",
        "type": _vm.statusList[item.status - 1].style
      }
    }, _vm._l((_vm.statusList), function(status) {
      return _c('li', {
        staticClass: "btn-block"
      }, [_c('button', {
        staticClass: "btn-block btn-link",
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.changeStatus(item, status)
          }
        }
      }, [_vm._v("\n                                  " + _vm._s(status.title) + "\n                                ")])])
    }), 0)], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-3 pull-right"
    }, [(typeof _vm.detailItem === 'object' && _vm.detailItem.pk === item.pk) ? _c('button', {
      class: [
        'btn btn-success',
        typeof _vm.details[item.pk] !== 'undefined' && _vm.details[item.pk].length === 0 ? 'disabled' : ''
      ],
      on: {
        "click": function($event) {
          return _vm.closeDetail()
        }
      }
    }, [(typeof _vm.details[item.pk] === 'undefined') ? _c('i', {
      staticClass: "fa fa-spin fa-spinner"
    }) : (typeof _vm.details[item.pk] !== 'undefined' && _vm.details[item.pk].length > 0) ? _c('i', {
      staticClass: "fa fa-chevron-up"
    }) : _c('i', {
      staticClass: "fa fa-spin fa-dot-circle-o"
    })]) : _c('button', {
      class: [
        'btn btn-success',
        typeof _vm.details[item.pk] !== 'undefined' && _vm.details[item.pk].length === 0 ? 'disabled' : ''
      ],
      on: {
        "click": function($event) {
          return _vm.openDetail(item)
        }
      }
    }, [(typeof _vm.details[item.pk] === 'undefined' || _vm.details[item.pk].length > 0) ? _c('i', {
      staticClass: "fa fa-chevron-down"
    }) : _c('i', {
      staticClass: "fa fa-spin fa-dot-circle-o"
    })])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-3 col-xs-12"
    }, [_vm._v("\n                        " + _vm._s(_vm._f("moment")(item.inserted, "MMM DD hh:mm:ss")) + " \n                      ")]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-5 col-xs-12"
    }, [_c('strong', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s(item.message) + "\n                      ")])])])])]), _vm._v(" "), (typeof _vm.details[item.pk] !== 'undefined' && _vm.detailItem.pk === item.pk) ? _c('div', {
      staticClass: "col-md-12",
      staticStyle: {
        "background-color": "#fffff"
      }
    }, _vm._l((_vm.details[item.pk]), function(row) {
      return _c('div', {
        staticClass: "row",
        staticStyle: {
          "border-bottom": "1px solid #000000",
          "margin-top": "10px",
          "padding-bottom": "10px"
        }
      }, [_c('div', {
        staticClass: "col-xs-12 col-md-1"
      }, [_vm._v("\n                    " + _vm._s(_vm._f("moment")(row.dt, "MMM DD hh:mm:ss")) + " \n                  ")]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 col-md-1"
      }, [_vm._v("\n                    " + _vm._s(row.server) + " \n                  ")]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 col-md-2"
      }, [_vm._v("\n                    " + _vm._s(row.program) + " \n                  ")]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 col-md-1"
      }, [_vm._v("\n                    Line: " + _vm._s(row.linenum) + " \n                  ")]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 col-md-7"
      }, [_vm._v("\n                    " + _vm._s(row.message) + " \n                  ")])])
    }), 0) : _vm._e()])
  }), 0) : _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-4x fa-spin fa-spinner loader"
  })])]), _vm._v(" "), (_vm.allResolved && _vm.log.length > 0 && !_vm.showResolved) ? _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleShowResolved()
      }
    }
  }, [_vm._v("\n            Show Resolved\n          ")])]) : _vm._e()])])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 344:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),

/***/ 345:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.size === 'large' ? 'nav-md' : 'nav-sm']
  }, [_c('div', {
    staticClass: "container body"
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('sidebar', {
    attrs: {
      "title": "Edexis",
      "menuItems": _vm.menuItems,
      "logout": _vm.logout.bind(this)
    }
  }), _vm._v(" "), _c('topmenu', {
    on: {
      "toggleSidebar": function($event) {
        return _vm.toggleSidebar()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right_col",
    staticStyle: {
      "min-height": "1080px"
    },
    attrs: {
      "role": "main"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _vm._m(0)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "clearfix"
  })])
}]}

/***/ }),

/***/ 346:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "x_panel"
  }, [_c('div', {
    staticClass: "x_title"
  }, [_vm._t("title"), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('form', {
    staticClass: "form-horizontal",
    staticStyle: {
      "display": "inline"
    }
  }, [(_vm.filter && _vm.showPanel) ? _c('div', {
    class: [
      'col-md-4 input-group',
      _vm.filterText !== '' ? 'borderfix' : ''
    ]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterText),
      expression: "filterText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Filter"
    },
    domProps: {
      "value": (_vm.filterText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterText = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.filterText !== '') ? _c('span', {
    class: [
      'input-group-btn'
    ]
  }, [_c('button', {
    staticClass: "btn btn-link btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-right panel_toolbox"
  }, [_vm._t("toolbar-start"), _vm._v(" "), _vm._t("toolbar", function() {
    return [_c('li', [_c('a', {
      attrs: {
        "title": "Hide Panel Contents"
      },
      on: {
        "click": function($event) {
          return _vm.togglePanelDisply()
        }
      }
    }, [_c('i', {
      class: [
        'fa fa-chevron-up',
        _vm.showPanel ? 'fa-chevron-up' : 'fa-chevron-down'
      ]
    })])])]
  }), _vm._v(" "), _vm._t("toolbar-end")], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2), _vm._v(" "), (_vm.showPanel) ? _c('div', {
    staticClass: "x_content"
  }, [_vm._t("content")], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 350:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[243]);


// WEBPACK FOOTER //
// static/js/app.4200ac9b0555262d289c.js